import React from "react"
import { RenderElementProps } from "slate-react"

const HeadingSeo = ({ children, attributes }: RenderElementProps) => {
    return (
        <div {...attributes} className="mb-3 text-base last:mb-0 sm:text-lg sm:font-semibold lg:mb-5 lg:text-xl">
            {children}
        </div>
    )
}

export default HeadingSeo
